// import { Badge } from "react-bootstrap";
// import BadgeEstados from "../../components/BadgeEstado";
// import AccionesActaTable from "../../views/Acciones/AccionesActaTable";
// import HeaderColumn from "./components/HeaderColumn";

import BadgeEstado from "../../../components/BadgeEstado";
import BadgeEstadoActa from "../../../components/BadgeEstadoActa";
import EyeIcon from "../../../components/svgs/EyeIcon";
import { handlerGetActa } from "../../../handlers/actas.handler";
import { handlerGetActaInspector } from "../../../handlers/inspector.handler";

//!REVISAR
// import "./style.css";

export const tableData = (data, width, path) => {
  const columns = [
    // { field: "id", headerName: "ID", hide: true },
    // {
    //   field: "actions",
    //   headerName: "",
    //   minWidth: width >= 640 ? 100 : 35,
    //   flex: width >= 640 ? 0.6 : 0.4,
    //   sortable: false,
    //   headerClassName: "headerActions",
    //   renderCell: (params) => (
    //     <div
    //       onClick={() => {
    //         if (path == "/mis_solicitudes") {
    //           handlerGetActa(params.row.id);
    //         }
    //       }}
    //       className={`d-flex  align-items-center text-dark ${
    //         width >= 640 ? " text-white  gap-1 bg-primary px-2 rounded py-1 " : ""
    //       }    `}
    //     >
    //       <EyeIcon width={20} height={20} />
    //       {width >= 640 && <span>Detalle</span>}
    //     </div>
    //   ),
    // },
    {
      field: "fecha",
      headerName: "Fecha",
      minWidth: width >= 640 ? 88 : 88,
      flex: width >= 640 ? 0.5 : 0.4,
      sortable: false,
      headerClassName: "headerActions",
      renderCell: (params) => (
        <div>
          {params.row.fecha ? params.row.fecha : <span className="text-danger">No tiene feha</span>}
        </div>
      ),
    },
    {
      field: "estado_acta",
      headerName: "Estado",
      headerClassName: "custom-header",
      // minWidth: width >= 640 ? 150 : 80,
      minWidth: 80,
      flex: 0.5,
      sortable: false,
      renderCell: (params) => {
        return <BadgeEstadoActa estado={params.row.estado_acta} />;
      },
    },
    {
      field: "tipo",
      headerName: "Tipo solicitud",
      minWidth: width >= 640 ? 235 : 110,
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        return (
          <div className="w-100">
            {params?.row?.tipo?.length > 0 ? (
              <div className="m-0">
                <>
                  {params.row.tipo.map((tipo, index) => {
                    return (
                      <div key={index} style={{ lineHeight: "13px" }}>
                        <span style={{ fontSize: "12px" }} className="fw-bold">
                          {tipo.nombre}
                        </span>{" "}
                        <span
                          style={{ fontSize: "11px" }}
                        >{` | ${tipo.cantidad_arboles} árboles`}</span>
                      </div>
                    );
                  })}
                </>
              </div>
            ) : (
              <div>
                <span className="text-danger">No tiene tipo asignado</span>
              </div>
            )}
          </div>
        );
      },
    },

    {
      field: "barrio",
      headerName: "Barrio",
      minWidth: width >= 640 ? 150 : 120,
      flex: 1,
      sortable: false,
      //   renderHeader: () => {
      //     return (
      //       <HeaderColumn
      //         label={"N° Acta"}
      //         color={"#FFF"}
      //         setFiltersField={setFiltersField}
      //         setOrder={setOrder}
      //         setOrderField={setOrderField}
      //         typeInput={"number"}
      //         field={"numero_acta"}
      //         place={"Acta"}
      //       />
      //     );
      //   },
    },
    {
      field: "lugar",
      headerName: "Lugar",
      minWidth: width >= 640 ? 150 : 150,
      flex: 1,
      sortable: false,
      //   renderHeader: () => {
      //     return (
      //       <HeaderColumn
      //         label={"Tipo infracción"}
      //         color={"#FFF"}
      //         setFiltersField={setFiltersField}
      //         setOrder={setOrder}
      //         setOrderField={setOrderField}
      //         typeInput={"select"}
      //         field={"tipo"}
      //         place={"Tipo"}
      //       />
      //     );
      //   },
    },
    // ...(estado_id === 8 || estado_id == 4 || estado_id == 11
    //   ? [
    //       {
    //         field: "notificador_nombre",
    //         headerName: "Notificador",
    //         minWidth: 300,
    //         flex: 2,
    //         sortable: false,
    //         renderHeader: () => {
    //           return (
    //             <HeaderColumn
    //               label={"Notificador"}
    //               color={"#FFF"}
    //               setFiltersField={setFiltersField}
    //               setOrder={setOrder}
    //               setOrderField={setOrderField}
    //               typeInput={"text"}
    //               field={"notificador"}
    //               place={"Notificador"}
    //             />
    //           );
    //         },
    //         renderCell: (params) => {
    //           return (
    //             <>
    //               <span
    //                 className={`${params.row.tipo_acta_generada == "DIGITAL" ? "  px-2 rounded fw-bold" : params.row.notificador_nombre ? "" : "text-danger"}`}
    //               >
    //                 {params.row.tipo_acta_generada == "DIGITAL"
    //                   ? "Mi Muni Digital"
    //                   : params.row.notificador_nombre
    //                     ? params.row.notificador_nombre
    //                     : "No tiene notificador"}
    //               </span>
    //             </>
    //           );
    //         },
    //       },
    //     ]
    //   : []),
  ];

  const rows =
    data?.map((d) => {
      return {
        fecha: d?.fecha_solicitud,
        id: d?.id,
        // tipo: d?.tipo?.nombre,
        tipo: d?.tipos_solicitud,
        // barrio: d?.barrio_original?.descripcion,
        barrio: d?.barrio,
        lugar: d?.lugar,
        // direccion: d?.barrio?.direccion,
        estado: d?.estado_id,
        // estado_acta: d?.estado?.estado,
        estado_acta: d?.estado,
      };
    }) || [];

  const filter = (d, value) => {
    value = value.toLowerCase();
    return (
      String(d.id)?.toString().toLowerCase().includes(value) ||
      String(d.plate)?.toString().toLowerCase().includes(value) ||
      String(d.fecha_hora)?.toString().toLowerCase().includes(value) ||
      String(d.infraccion)?.toString().toLowerCase().includes(value) ||
      String(d.documento)?.toString().toLowerCase().includes(value) ||
      String(d.localidad)?.toString().toLowerCase().includes(value) ||
      String(d.numero_acta)?.toString().toLowerCase().includes(value) ||
      String(d.numero_acta)?.toString().toLowerCase().includes(value)
    );
  };

  return { columns, rows, filter };
};
